'use strict';

import _ from 'lodash';
import classnames from 'classnames';
import './PaymentPlan.less';

import React from 'react';
import PropTypes from 'prop-types';
import langToReactElements from 'ck-core-client/source/functions/langToReactElements';
import WithCoupon from './WithCoupon.jsx';
import CurrencyPropType from './CurrencyPropType';
import CouponPropType from './CouponPropType';
import subscriptionPlans from 'ck-core/source/collections/subscriptionPlans';
import PaymentPlanLang from './PaymentPlanLang';
import productMeta from 'ck-core/source/data/productMeta';
import couponBackground from 'ck-core-client/graphics/checkout/checkout-coupon-background.svg';
import RoundButton from 'ck-core-client/source/ui/RoundButton';

class PaymentPlan extends React.Component {
	render() {
		const { translucent, highlighted } = this.props;

		const planCursor = subscriptionPlans(this.props.planId);

		const product = planCursor.product();

		let coupon;

		if (
			this.props.coupon &&
			planCursor.isCouponApplicable(this.props.coupon, this.props.currency)
		) {
			coupon = this.props.coupon;
		}

		const priceInCurrency = planCursor.priceInCurrency(this.props.currency, {
			coupon,
			html: false,
			user: CK.user
		});

		let fullPrice;

		if (priceInCurrency.discount > 0) {
			fullPrice = priceInCurrency.formattedFullPriceStylishly;
		}

		let formattedIntervalTitle = planCursor.formattedIntervalTitle();

		if (!formattedIntervalTitle || !_.isString(formattedIntervalTitle)) {
			CK.logger.warn('formattedIntervalTitle is nil', {
				planId: this.props.planId
			});

			formattedIntervalTitle = '';
		}

		//TODO: Logic to not show coupon on generic coolmath promo but on other promos
		let hiddenCoupon = false;

		// if (this.props.coupon && this.props.coupon === 'coolmathdiscountedprices') {
		// 	hiddenCoupon = true;
		// }

		if (CK.isCoolMath && CK.isCoolMath()) {
			hiddenCoupon = true;
		}

		const classes = classnames(
			'PaymentPlan',
			'PaymentPlanLike',
			'duration' + formattedIntervalTitle.replace(/\s/g, ''),
			`product${_.upperFirst(product)}`,
			this.props.coupon && !hiddenCoupon ? 'PaymentPlan--coupon' : null,
			this.props.className
		);

		let equivalentTo;

		const equivalentToEnabled = false;

		if (equivalentToEnabled && planCursor.oneOff() && !planCursor.lifetime()) {
			if (planCursor.interval() === 'year') {
				equivalentTo =
					PaymentPlanLang.EQUIVALENT_TO +
					CK.fn.formatPrice(this.props.currency, priceInCurrency.price / 12, {
						html: false
					}) +
					' / month';
			} else {
				equivalentTo =
					PaymentPlanLang.EQUIVALENT_TO +
					priceInCurrency.formattedPerInterval +
					' / ' +
					planCursor.interval();
			}
		}

		let billingDescription;

		if (planCursor.oneOff()) {
			billingDescription = PaymentPlanLang.ONE_OFF;
		} else {
			billingDescription = PaymentPlanLang[planCursor.durationKey()];
		}

		let family = '';

		if (planCursor.family()) {
			family = PaymentPlanLang.FAMILY_SUFFIX;
		}

		// TODO: formattedStylishly should be in here, not in SubscriptionPlanSchema
		return (
			<div
				className={`Payment__wrapper ${translucent ? 'PaymentPlan--translucent' : ''} ${
					highlighted ? 'PaymentPlan--highlighted' : ''
				}`}
			>
				<div
					className={classes}
					onClick={() => this.props.onClick(this.props.coupon)}
					id={`plan-${this.props.planId}`}
				>
					{formattedIntervalTitle == 'Annually' && !family && (
						<div className="anchor">Most Popular</div>
					)}

					<div className="productName">
						{productMeta[product].name}
						{family}
					</div>

					<div className="name">{planCursor.formattedIntervalTitle()}</div>

					<div
						className="price"
						dangerouslySetInnerHTML={{ __html: priceInCurrency.formattedStylishly }}
					/>

					{equivalentTo && <div className="equivalentTo">{equivalentTo}</div>}

					<div
						className="billingDescription"
						dangerouslySetInnerHTML={{ __html: billingDescription }}
					/>

					<RoundButton
						buttonClass="checkoutButton"
						text={'Checkout'}
						colour="yellow"
						size="small"
						hoverAnimation="hvr-bounce-in"
					/>
				</div>

				{fullPrice && !hiddenCoupon && (
					<div className="PaymentPlan__coupon">
						<div className="PaymentPlan__coupon-back">
							<img src={couponBackground} />
						</div>
						<div className="PaymentPlan__was">
							{'WAS'}
							<div
								className="PaymentPlan__was-price"
								dangerouslySetInnerHTML={{ __html: fullPrice }}
							/>
						</div>
						<div
							className="PaymentPlan__discount"
							dangerouslySetInnerHTML={{
								__html: coupon && coupon.getMessage(planCursor, this.props.currency)
							}}
						>
							{/* {priceInCurrency.upgradeDiscount ? (
								<div>
									UPGRADE
									<div className="PaymentPlan__discount-save">{priceInCurrency.formattedUpgradeDiscount} OFF</div>
								</div>
							) : (
								''
							)} */}
						</div>
					</div>
				)}
			</div>
		);
	}
}

export const planIdPropType = PropTypes.string.isRequired;

PaymentPlan.propTypes = {
	planId: planIdPropType,
	currency: CurrencyPropType.isRequired,
	coupon: CouponPropType,
	onClick: PropTypes.func.isRequired,
	className: PropTypes.string,
	translucent: PropTypes.bool,
	highlighted: PropTypes.bool
};

export default WithCoupon(PaymentPlan);
